import { EventEmitter, Injectable } from '@angular/core';
import { NotifyParams } from '../models/common-model';

@Injectable()
export class ProcessNotificationService {
  dataNotify = new EventEmitter<NotifyParams>();
}